import { Component, OnInit } from '@angular/core';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { AuthenticationService } from '../service/authentication.service';
import { MessageConstants } from '../constants/message-constants';

@Component({
  selector: 'ncc-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss']
})
export class TncComponent implements OnInit {

  tnc: any = {
    name: null,
    description: null,
    url: null,
    version: null,
    effectiveDate: null,
    id: null
  };
  isTnCAccepted: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    let accountStatus = this.apiService.accountDetail.status;
    
    // DONOT remove this code, when Tnc in Place we need this
    if (accountStatus == Constants.INACTIVE || accountStatus == Constants.PENDING) {
      // document.getElementById("openTnc").click();
      this.getTncForAccount();
    }
  }

  getTncForAccount() {
    // this.utilService.showSpinner();
    this.apiService.getTncForAccount().then((data) => {
      // this.utilService.hideSpinner();
      this.tnc = data;
      document.getElementById("openTnc").click();
      console.log("TnC data::", this.tnc);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          // this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getTncForAccount();
        });
      } else if (error.status == Constants.HTTP_NOT_FOUND) {
        // this.utilService.hideSpinner();       
      } else {
        // this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  acceptTnC(payload: any) {
    if (!this.isTnCAccepted) return;
    this.utilService.showSpinner();
    this.apiService.acceptTnC(payload).then((data) => {
      this.apiService.accountDetail.status = Constants.ENABLED;
      this.utilService.hideSpinner();
      document.getElementById("closeTnc").click();
      console.log("TnC accept data::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.acceptTnC(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  acceptTnc() {
    var payload = {
      "tncProfileId": this.tnc.id
    }
    this.acceptTnC(payload);
  }

  /* acceptTnc() {
    this.utilService.showSpinner();
    this.apiService.getClientIpAddress().then((data) => {
      this.utilService.hideSpinner();
      console.log("IP Address::", data);
      if(data && data.query) {
        var payload = {
          "tncProfileId": this.tnc.id,
          "userIp": data.query
        }
        this.acceptTnC(payload);
      }
    }).catch((error) => {
      console.log("err : ", error);
      this.toast.showError(Constants.UNKNOWN_ERROR);
      this.utilService.hideSpinner();
    });
  } */

}
